/**
 * @module Experience/one-time-payment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

export const ONE_TIME_PAYMENT_MODULE_NAME = 'OneTimePaymentModule';

export const ONE_TIME_PAYMENT_CONSTANTS = {
  autopayRoute: '/autopay',
  CART_PAYMENT_ROUTE: '/cart/payment/instore',
  DIRECT_TO_ACCOUNT_ROUTE: '/direct-to-account',
  OTP_LANDING: '/one-time-payment',
  REVIEW_OTP: '/one-time-payment/review',
  PAYMENT_OTP: '/one-time-payment/payment',
  CONFIRM_OTP: '/one-time-payment/confirm',
  PRIMARY: 'primary',
  PREPAID: 'prepaid',
  CARDDETAILS: 'cardDetails',
  LANDLINE: 'LANDLINE',
  RETAIL: 'retail',
  REJECT: 'REJECT',
  TRACK2: 'Track2',
  ONE: '1',
  MIGRATIONCODE:
    ' Since your acconut is in migration, your payment will be processed withing 36 hours.',
  SPLITPAYMENT: 'splitPayment',
  CASH: 'cash',
  BILLING_TYPE: 'billingtype',
  CREDIT: 'Credit',
  MIGRATIONHOURS: '36',
  REFILL_ACCOUNT: '/refill-account',
  PURCHASEEQUIPMENT: 'PURCHASEEQUIPMENT',
  MIGRATED_CODE: 'J',
  LEGAL_TEXT: 'legal-text',
  STEP_INDEX: '2',
  ACCOUNT_LANDING: '/account-landing',
  RECEIPT: 'receipt',
  TRANSACTION_CONFIRMATION: 'transaction-confirmation',
  ERROR_CODE: 'ORDER-1003',
  CONFIRMATION_CANCEL: 'Are you sure you want to cancel?',
  CANCELLING_CART:
    'Cancelling will abandon the entire cart, including devices, plans and services.',
  NO: 'No',
  CANCEL: 'cancel',
  BTN_SECONDARY: 'btn btn-secondary',
  BTN_TYPE_SECONDARY: 'Secondary',
  YES: 'Yes',
  SUBMIT: 'submit',
  BTN_PRIMARY: 'btn btn-primary',
  BTN_TYPE_PRIMARY: 'Primary',
  HOME: '/home',
  OTP_PAYMENT: 'one-time-payment/payment',
  CREDIT_CARD_PAY: 'Pay with Credit Card',
  REFILL_USE: 'Use Refill Card',
  CTA_BACK: 'Back',
  CTA_CONTINUE: 'Continue',
};

export const ADDRESS_FORM = {
  ADDRESS: 'address',
  FIRST_NAME: 'firstName',
  MIDDLE_NAME: 'middleName',
  LAST_NAME: 'lastName',
};

export const API_232_QUERYSTRING = {
  limit: 100,
  groupBy: 'NAME',
};

export const API_2603_CONST = {
  ADD: 'ADD',
  ORDER_TYPE: 'PURCHASEEQUIPMENT',
  CURRENCY: 'USD',
  DEFAULT_ZIP: '98006',
};
export const CARD_SWIPE_MODAL = {
  SWIPE_CARD_NOW: 'swipeCardNow',
};
export const ENCRYPTION_ERROR_MODAL = {
  SORRY_ABOUT_THAT: 'sorryAboutThat',
};
